import React from "react";

const MetricCard = ({ label, value, icon, color, showProgress }) => {
  const numVal = parseFloat(value);
  const pct = !Number.isNaN(numVal) && numVal <= 1 ? numVal * 100 : null;
  const accentColor = color || "#0d6efd";

  return (
    <div className="metric-card">
      <div
        className="metric-card__header"
        style={{ background: `${accentColor}12`, borderBottom: `1px solid ${accentColor}30` }}
      >
        <i className={`fa ${icon} metric-card__icon`} style={{ color: accentColor }} />
        <span className="metric-card__label">{label}</span>
      </div>
      <div className="metric-card__body">
        <div className="metric-card__value">{value}</div>
        {showProgress && pct !== null && (
          <div className="metric-card__progress">
            <div
              className="metric-card__progress-bar"
              style={{ width: `${Math.min(100, pct)}%`, background: accentColor }}
              role="progressbar"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;
